interface ResourceBarProps {
  label: string
  percentUsed: number
  /** Amount used (e.g. "2.29ms", "722B") */
  usedLabel: string
  /** Maximum / quota (e.g. "40.51ms", "1.7MB") */
  availLabel: string
}

export default function ResourceBar({ label, percentUsed, usedLabel, availLabel }: ResourceBarProps) {
  const color =
    percentUsed > 90 ? 'bg-danger' :
    percentUsed > 70 ? 'bg-warning' :
    'bg-success'

  return (
    <div className="space-y-1.5">
      <div className="flex justify-between items-center">
        <span className="text-xs font-semibold text-gray-300 uppercase tracking-wide">{label}</span>
        <span className={`text-xs font-medium ${percentUsed > 90 ? 'text-danger' : percentUsed > 70 ? 'text-warning' : 'text-success'}`}>
          {percentUsed}%
        </span>
      </div>
      <div className="resource-bar">
        <div
          className={`resource-bar-fill ${color}`}
          style={{ width: `${Math.min(percentUsed, 100)}%` }}
        />
      </div>
      <div className="flex justify-between text-[11px] text-gray-500">
        <span>{usedLabel}</span>
        <span className="text-gray-600">/ {availLabel}</span>
      </div>
    </div>
  )
}
